import React from 'react';
import PropTypes from 'prop-types';
import {uid} from "react-uid";
import TableCell from "./TableCell";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import makeStyles from "@material-ui/core/styles/makeStyles";

function createNewPath(path, index) {
    let newPath = path.split('.');
    newPath[newPath.length - 1] = `${newPath[newPath.length - 1]}.${index}`;
    return newPath.join('.');
}

const useStyles = makeStyles(() => ({
    flexRow: {
        display: 'flex',
        height: '27px'
    },
}));

const TableRow = (props) => {
    const {
        arrayPath, element: {children, properties: {allowCreate, allowDelete, path}},
        indexValue, isHidden, tableUID, setActiveCell, onOpenContext, addGroup, removeGroup,
        arrayLength, visibleIndex, goBack
    } = props;
    const classes = useStyles();
    let isCreatable = allowCreate === true || allowCreate === undefined;
    let isRemovable = allowDelete === true || allowDelete === undefined;
    const elementPath = arrayPath ? arrayPath : path;
    const newPath = createNewPath(elementPath, indexValue);
    const uniqueIdRow = uid(`${visibleIndex}_${path}`);
    const eventListenerHandler = (e) => {
        if (e.altKey && e.key === 'ArrowLeft') {
            e.preventDefault();
            goBack();
        }

        //add before
        if (e.ctrlKey && e.shiftKey && e.key === 'Insert') {
            //check is allow to create(check for undefined, because in old format allowCreate isn't present)
            if (isCreatable) {
                addGroup(path, indexValue);
                return;
            }
        }
        //add after
        if (e.ctrlKey && e.key === 'Insert') {
            if (isCreatable) {
                addGroup(path, indexValue + 1);
                return;
            }
        }
        //delete
        if (e.ctrlKey && e.key === 'Delete') {
            if (isRemovable && !Boolean(indexValue === 0 && arrayLength === 1)) {
                removeGroup(`${path}.${indexValue}`);
            }
        }
    };
    return (
        !Boolean(isHidden) ? (
            <div id={uniqueIdRow} style={{height: '27px'}}
                 className={classes.flexRow}
                 onKeyDown={eventListenerHandler}
                 onContextMenu={(e) =>
                     onOpenContext(e, `${elementPath}.${indexValue}`, elementPath, indexValue, {
                             after: !Boolean(isCreatable),
                             before: !Boolean(isCreatable),
                             remove: !Boolean(isRemovable) || (indexValue === 0 && arrayLength === 1)
                         }
                     )}
            >
                {children.map((field, rowIndex) => {
                    let cellUID = `${visibleIndex + 1}_${rowIndex + 1}_${tableUID}`;
                    return (
                        <RenderCell
                            key={`${field.name}${rowIndex}`}
                            setActiveCell={setActiveCell}
                            field={field}
                            isHidden={isHidden}
                            indexValue={indexValue}
                            newPath={newPath}
                            cellUID={cellUID}
                        />
                    )
                })}
            </div>
        ) : (<></>)
    )
};
TableRow.propTypes = {
    arrayPath: PropTypes.string,
    element: PropTypes.object,
    indexValue: PropTypes.number,
    isHidden: PropTypes.bool,
    tableUID: PropTypes.string,
    setActiveCell: PropTypes.func,
    onOpenContext: PropTypes.func,
    arrayLength: PropTypes.number
};
export default JsonScreenHoc(TableRow);

const RenderCell = (props) => {
    const {
        field, indexValue,
        newPath, isHidden, setActiveCell, cellUID
    } = props;

    const horizontalArrayStyles = field.styles.map((item, index) => {
        if (index === 0) { //field styles object
            return {...item, withoutStyles: true, fullWidth: true}
        }
        return item
    });

    if (field.properties.hidden) return <></>;
    return (
        <TableCell
            isHidden={isHidden}
            field={{...field, styles: horizontalArrayStyles}}
            setActiveCell={setActiveCell}
            valueIndex={indexValue}
            arrayPath={`${newPath}.${field.properties.name}`}
            newPath={newPath}
            indexValue={indexValue}
            id={cellUID}
            showLabel
        />
    )
};